import moment from 'moment';
import ReactLoading from 'react-loading';

// Utility imports
import { useGet } from '../../../../reducers/useGet';
import AuthService from '../../../../services/auth';

// Component imports
import { LineChart2Elements } from '../../charts';
import ErrorMessage from '../../messages-panel/error-message';

// Styles
import { useEffect, useState } from 'react';
import { BiWater } from 'react-icons/bi';
import './well-level-panel.css';

// Constantes
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm';

export default function WellLevelPanel({ sensor, panelType }) {
	const { access_token } = AuthService.getCurrentUser();
	const [chartData, setChartData] = useState([]);

	const getWellLevelData = useGet(
		`evento_consulta?sensor=${sensor.id_dispositivo}&tipo_mensagem=1`,
		access_token
	);

	useEffect(() => {
		// Verifica se todos os dados necessários já foram carregados
		const isDataReady =
			!getWellLevelData.state.loading &&
			!getWellLevelData.state.error &&
			getWellLevelData.state.data;

		if (!isDataReady) return;

		// Lista auxiliar dos dados para gráfico com duas linhas
		const chartDataAuxArray = getWellLevelData.state.data.map((d) => {
			if (!d.data || !d.valor_sensor) return null; // Ignora dados inválidos
			return {
				timestamp: moment(d.data).format(DATE_FORMAT),
				value1: +d.valor_sensor, // Valor dinâmico (sensor)
				value2: +d.correcao, // Valor estático (correção)
			};
		});

		const filteredData = chartDataAuxArray.filter(Boolean);
		setChartData(filteredData);
	}, [getWellLevelData.state.data, getWellLevelData.state.loading, getWellLevelData.state.error]);

	// Verificação de estado de carregamento
	const isLoading =
		getWellLevelData.state.loading ||
		getWellLevelData.state.loading ||
		getWellLevelData.state.loading;

	// Verificação de estado de erro
	const hasError =
		getWellLevelData.state.error || getWellLevelData.state.error || getWellLevelData.state.error;

	// Renderiza o componente de carregamento
	if (isLoading) {
		return (
			<div>
				<div className="panel-title-container">
					<em className="panel-title">{sensor.tag}</em>
				</div>
				<div className="panel-loading">
					<ReactLoading
						type="spinningBubbles"
						color="var(--main-color)"
						width="50px"
						height="50px"
					/>
				</div>
			</div>
		);
	}

	// Renderiza mensagem de erro
	if (hasError) {
		return (
			<div>
				<div className="panel-title-container">
					<em className="panel-title">{sensor.tag}</em>
				</div>
				<ErrorMessage />
			</div>
		);
	}

	// Renderiza o conteúdo principal
	return (
		<div>
			<div className="panel-title-container">
				<em className="panel-title">{sensor.tag}</em>
			</div>
			<div style={{ margin: '10px' }}>
				<div className="well-level-chart-section">
					<div className="well-level-section-header">
						<BiWater className="well-level-section-icon" />
						<span className="well-level-section-title">Histórico do Nível do Poço</span>
					</div>

					<LineChart2Elements
						data={chartData}
						unit={'m'}
						name1="Nível Dinâmico"
						name2="Nível Estático"
						color1="#0077B6"
						color2="#DC3545"
						fileName={`grafico-nivel-poco-${sensor.tag}`}
					/>
				</div>
			</div>
		</div>
	);
}
